/**
 * Return a time dependent greeting based on the hour of the day
 * @param hour - the local time hour (0 to 23) of a date
 * @returns - Greeting message string
 */
export function getUserGreeting(hour: number): string {
  let greeting = 'Good morning';
  if (hour >= 12 && hour < 18) {
    greeting = 'Good afternoon';
  } else if (hour >= 18) {
    greeting = 'Good evening';
  }
  return greeting;
}

/**
 * Calculate and return expiration date difference in days number
 * @param expiredDateString - an exipration date string
 * @returns - difference in days if certificate has expired
 */
export function calculateExpirationDate(expiredDateString: string): number {
  let diffDays = 0;
  if (expiredDateString) {
    const expiryDate: any = new Date(expiredDateString);
    const currentDate: any = new Date();
    const oneDay = 24 * 60 * 60 * 1000;
    diffDays = Math.round((expiryDate.getTime() - currentDate.getTime()) / oneDay);
  }
  return diffDays;
}

/**
 * Return expiration time which is the current time + 12 hours in milliseconds to determine
 * how long search results can live in cache.
 * @returns number of current time + 12 hours in milliseconds
 */
export function getExpirationTime(): number {
  const additionalHours = 43200000; // 12 hours in milliseconds
  return new Date().getTime() + additionalHours; // current time + 12 hours
}
